<template>
  <aside class="sidebar">
    <div
      v-for="section in sections"
      :key="section.label"
      class="sb-section"
    >
      <div class="sb-label">{{ section.label }}</div>
      <router-link
        v-for="it in section.items"
        :key="it.label"
        :to="it.to || '#'"
        :event="it.to ? 'click' : ''"
        custom
        v-slot="{ navigate, isActive }"
      >
        <div
          class="sb-item"
          :class="{ active: isItemActive(it, isActive), disabled: !it.to }"
          @click="it.to && navigate($event)"
        >
          <span class="s-icon" v-html="it.icon" />
          <span class="sb-text">{{ it.label }}</span>
          <span v-if="it.badge != null" class="sb-badge">{{ it.badge }}</span>
        </div>
      </router-link>
    </div>
  </aside>
</template>

<script>
// SVG icons inlined to match the mockup (stroke style, currentColor).
// Keep them small — sidebar paints them via `.s-icon svg` styling.
const ICONS = {
  dashboard:
    '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',
  shield:
    '<svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
  orders:
    '<svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
  tx:
    '<svg viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>',
  docs:
    '<svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
  commission:
    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M16 8 8 16"/><circle cx="9" cy="9" r="1.5"/><circle cx="15" cy="15" r="1.5"/></svg>',
  config:
    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>',
  admins:
    '<svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  security:
    '<svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
  funding:
    '<svg viewBox="0 0 24 24"><rect x="2" y="6" width="20" height="13" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="6" y1="15" x2="9" y2="15"/></svg>',
  tests:
    '<svg viewBox="0 0 24 24"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
}

export default {
  name: 'AppSidebar',
  data() {
    return {
      sections: [
        {
          label: 'Главное',
          items: [
            { label: 'Дашборд',     icon: ICONS.dashboard, to: null /* not implemented */ },
            { label: 'KYC-панель',  icon: ICONS.shield,    to: '/users', matchNames: ['Users', 'UserDetail'] },
            { label: 'Финансы',     icon: ICONS.funding,   to: '/admin/funding', matchNames: ['Funding'] },
            { label: 'Депозит-адреса', icon: ICONS.funding, to: '/admin/network-wallets', matchNames: ['NetworkWallets'] },
            { label: 'Ордера',      icon: ICONS.orders,    to: '/admin/orders', matchNames: ['OrdersQueue'] },
            { label: 'Документы',   icon: ICONS.docs,      to: '/doclist', matchNames: ['DocList'] },
            { label: 'Комиссии',    icon: ICONS.commission, to: '/commissionref', matchNames: ['CommissionRef'] },
            { label: 'Конфигурация', icon: ICONS.config,   to: '/configuration', matchNames: ['Configuration'] },
            { label: 'Тесты',        icon: ICONS.tests,    to: '/tests', matchNames: ['TestsEditor'] },
          ],
        },
        {
          label: 'Система',
          items: [
            { label: 'Администраторы', icon: ICONS.admins,   to: '/system-users', matchNames: ['SystemUsers'] },
            { label: 'Безопасность',  icon: ICONS.security, to: '/security', matchNames: ['Security', 'TwoFactorSetup'] },
          ],
        },
      ],
    }
  },
  methods: {
    // router-link's isActive doesn't recognise sub-routes like /userdetail/:id
    // as belonging to "Users". Fall back to a name allow-list per item.
    isItemActive(item, routerActive) {
      if (routerActive) return true
      if (!item.matchNames) return false
      const name = this.$route && this.$route.name
      return name && item.matchNames.includes(name)
    },
  },
}
</script>

<style scoped>
.sidebar {
  width: var(--sidebar-w);
  background: #fff;
  border-right: 1px solid var(--c-border);
  padding: 20px 12px;
  flex-shrink: 0;
  position: sticky;
  top: var(--nav-h);
  height: calc(100vh - var(--nav-h));
  overflow-y: auto;
}

.sb-section { margin-bottom: 24px; }
.sb-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--c-muted);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 0 10px;
  margin-bottom: 8px;
}

.sb-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 9px 11px;
  border-radius: var(--r-md);
  font-size: 13px;
  color: var(--c-text-3);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 1px;
  text-decoration: none;
}
.sb-item:hover { background: #F5F5F5; color: #111; }
.sb-item.active { background: var(--c-accent-bg); color: var(--c-accent-dark); font-weight: 700; }
.sb-item.disabled { cursor: not-allowed; opacity: 0.55; }
.sb-item.disabled:hover { background: transparent; color: var(--c-text-3); }

.s-icon { width: 22px; height: 22px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.s-icon >>> svg {
  width: 17px; height: 17px;
  stroke: currentColor; fill: none;
  stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round;
}

.sb-text { flex: 1; }

.sb-badge {
  margin-left: auto;
  background: #F0F1F3;
  color: var(--c-text-3);
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
}
.sb-item.active .sb-badge {
  background: #D1FAE5;
  color: var(--c-success);
}
</style>
